<tt-offline-guidelines-table class="tt-offline-dashboard_table" />
